import { Epic } from 'redux-observable';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import {
  receiptsViewInit,
  receiptsViewOnFetchReceiptsFailed,
  receiptsViewOnFetchReceiptsRequest,
  receiptsViewOnFetchReceiptsSuccess,
} from '../receiptsViewSlice';
import { RootState } from '../../../../store';
import { from } from 'rxjs';
import { ReceiptsViewServiceImpl } from '../services';

type IN = ReturnType<typeof receiptsViewOnFetchReceiptsRequest>;
type OUT =
  | ReturnType<typeof receiptsViewOnFetchReceiptsSuccess>
  | ReturnType<typeof receiptsViewOnFetchReceiptsFailed>;

export const ReceiptsViewOnFetchReceiptsEpic: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(receiptsViewOnFetchReceiptsRequest.match),
    withLatestFrom(state$),
    switchMap(([, state]) => {
      return from(
        ReceiptsViewServiceImpl.getReceiptsData()
          .then((data) => receiptsViewOnFetchReceiptsSuccess(data))
          .catch((error) => {
            console.error(error);
            return receiptsViewOnFetchReceiptsFailed({
              msg: 'Failed to fetch data',
            });
          }),
      );
    }),
  );
